import React from 'react';
import {
  MdArrowBack, MdChevronRight, MdAccountBalanceWallet, MdSwapHoriz,
  MdOutlineShoppingCart, MdNotificationsNone, MdReportProblem, MdCreditCardOff, MdDevices,
} from 'react-icons/md';

const SecurityScreen = ({ onNavigate, onBack }) => {
  const securityItems = [
    { label: "Wealth protection",    icon: <MdAccountBalanceWallet /> },
    { label: "Sign-in methods",      icon: <MdSwapHoriz /> },
    { label: "Merchants and payments", icon: <MdOutlineShoppingCart /> },
    { label: "Gambling block",       icon: <MdNotificationsNone /> },
  ];

  const quickActions = [
    { label: 'Report fraud', icon: <MdReportProblem /> },
    { label: 'Lost card',    icon: <MdCreditCardOff /> },
    { label: 'Devices',      icon: <MdDevices /> },
  ];

  return (
    <div className="screen security-screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Security</h1>
        </div>
      </header>

      <div className="bh-flow-body">
        <div className="bh-form-card">
          <div className="bh-action-row">
            {quickActions.map(({ label, icon }) => (
              <button key={label} className="bh-action-card">
                <div className="bh-action-card-icon">{icon}</div>
                <span>{label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="bh-form-card" style={{ padding: 0, gap: 0 }}>
          {securityItems.map((item, i) => (
            <button
              key={i}
              type="button"
              className="bh-recent-row"
              style={{ background: 'transparent' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2xs)', flex: 1, minWidth: 0 }}>
                <span style={{ color: 'var(--td-green)', display: 'inline-flex', fontSize: 20 }}>{item.icon}</span>
                <span className="bh-recent-row-name">{item.label}</span>
              </div>
              <MdChevronRight style={{ color: 'var(--bh-gray)' }} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SecurityScreen;
